<div class="container">
  @for (val of values; track trackByIndex(index, val); let first = $first; let index = $index) {
    <rt-input
      #charInput
      [maxLength]="1"
      [autoFocus]="first"
      (valueChange)="valueChange($event, index)"
      (focus)="valueSelect(index)"
      (blur)="onTouched()"
      type="number"
    />
  }
</div>
